<div class="section-header" mat-dialog-title>
  <mat-icon class="section-icon">email</mat-icon>
  <span class="section-title">{{ 'general.email' | transloco }}</span>
  <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div fxFlex="row" mat-dialog-content>
  <div fxLayout="column" fxLayoutAlign=" start">
    <div>
      <mat-label>{{ 'general.provideEmail' | transloco }}</mat-label>
    </div>
    <form [formGroup]="emailForm">
      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Enter your email"/>
        @if (emailForm.controls['email'].hasError('email')) {
          <mat-error>
            Please enter a valid email address.
          </mat-error>
        }
        @if (emailForm.controls['email'].hasError('required')) {
          <mat-error>
            Email is required.
          </mat-error>
        }
      </mat-form-field>
      <br/>
      <br/>
      <button (click)="onClose()" mat-raised-button type="submit" [disabled]="!emailForm.valid">
        <mat-icon>send</mat-icon>
        {{ 'general.save' | transloco }}
      </button>
    </form>
  </div>
</div>
